import React from 'react';
import { Box, Button, Icon, Container } from '@amzn/awsui-components-console';

interface NoWorkflowExecutionsProps {
    entityName: string;
    workflowId: string;
    workflowDefinitionName: string;
}

const NoWorkflowExecutions: React.FC<NoWorkflowExecutionsProps> = ({ entityName, workflowId, workflowDefinitionName }) => {
    
    let buttonHref: string | undefined = undefined;
    let showButton = true;

    if (workflowDefinitionName === 'ANCHOR_POINT_WORKFLOW') {
        showButton = false;
    } else if (workflowDefinitionName === 'ANCHOR_POINT_DELETE_WORKFLOW') {
        buttonHref = `#/deleteAnchorPointWorkflow?nodeId=${entityName}`;
    } else {
        buttonHref = `#/executeWorkflow/${workflowId}`;
    }

    return (
        <Container>
            <Box textAlign="center" padding={{ vertical: 'xxl', horizontal: 'l' }}>
                <Icon name="status-info" size="medium" />
                <Box margin={{ top: 's', bottom: 's' }}>
                    <h3>No workflow executions found</h3>
                </Box>
                <Box margin={{ bottom: 's' }}>
                    <p>
                        This entity ({entityName}) doesn't have any workflow executions for {workflowDefinitionName} yet.
                    </p>
                </Box>
                <Box margin={{ bottom: 's' }}>
                    <p>Create a new execution to get started.</p>
                </Box>
                {showButton && (
                    <Button variant="primary" href={buttonHref}>
                        Create New Execution
                    </Button>
                )}
            </Box>
        </Container>
    );
};

export default NoWorkflowExecutions;
